import { useState, useEffect } from 'react';
import { Grid, Button, Typography, Checkbox, FormControlLabel, Divider, TextField, Box, CircularProgress, Radio, RadioGroup } from '@mui/material';
import AudiencePage from 'components/audience/page/AudiencePage';
import CampaignPage from 'components/campaign/page/CampaignPage';
import { useSelector, useDispatch } from 'react-redux';
import { getListAPI as getAudianceList } from 'components/audience/AudienceAPI';
import { setAudienceList } from 'store/slice/ManufSlice';
import { getCampaignInfoByTemplateidAPI } from 'components/campaign/CampaignAPI';
import { setCampaignDashboardCampaignList } from 'store/slice/ManufSlice';
import { sendEmailCampaignAPI } from 'api/OmsFactoryopsWebServices';
import { addCampaignObj } from 'store/slice/ManufSlice';

export default function RunCampaignActionImpl() {
    const dispatch = useDispatch();
    const { audienceList } = useSelector((state) => state.manufslice);
    const [selectedAudience, setSelectedAudience] = useState([]);
    const {templateObj} = useSelector((state) => state.manufslice.templateDashboard);
    const {campaignList} = useSelector((state) => state.manufslice.campaignDashboard);
    const [searchAudience, setSearchAudience] = useState('');
    const [isRunning, setIsRunning] = useState(false);
    const [mode, setMode] = useState('manual'); // 'auto' or 'manual'
    const [audienceCount, setAudienceCount] = useState(10); // default value
    const [autoAudienceList, setAutoAudienceList] = useState([]);

    useEffect(() => {
        getAudianceList(() => { }, (list) => {
            dispatch(setAudienceList(list));
        });

        getCampaignInfoByTemplateidAPI(templateObj.id, () => { }, (data) => {
            dispatch(setCampaignDashboardCampaignList(data.filter(campaign => campaign.templateid === templateObj.id)));
        });
    }, []);

    useEffect(() => {
        
    }, [campaignList]);

    // Filter and sort audience list based on search, and exclude those already in a campaign
    const filteredAudienceList = audienceList
        .filter(aud =>
            // Exclude if this audience's email is already in any campaign's audienceemail
            !campaignList.some(c => c.audienceemail === aud.email) &&
            (
                aud.title?.toLowerCase().includes(searchAudience.toLowerCase()) ||
                aud.email?.toLowerCase().includes(searchAudience.toLowerCase())
            )
        )
        .sort((a, b) => (a.title || '').localeCompare(b.title || ''));

    // Update autoAudienceList whenever audienceCount, filteredAudienceList, or mode changes
    useEffect(() => {
        if (mode === 'auto') {
            setSelectedAudience([]);
            setAutoAudienceList(
                filteredAudienceList.slice(0, audienceCount).map(aud => ({
                    ...aud,
                    status: 'selected'
                }))
            );
        }
    }, [mode, audienceCount]);

    useEffect(() => {
    },[autoAudienceList]);

    const handleCheckboxChange = (audienceId) => {
        setSelectedAudience(prev =>
            prev.includes(audienceId)
                ? prev.filter(id => id !== audienceId)
                : [...prev, audienceId]
        );
    };

    const runCampaign = () => {
        setIsRunning(true);
        let pending = selectedAudience.length;
        for (const audId of selectedAudience) {
            const audObj = audienceList.find(a => a.id === audId);
            if (audObj) {
                sendEmailCampaignAPI({
                    templateId: templateObj.id,
                    audienceId: audObj.id,
                }, (response) => {
                    dispatch(addCampaignObj(response.campaignInfo));
                    setSelectedAudience(prev => prev.filter(id => id !== audId));
                    pending -= 1;
                    if (pending === 0) setIsRunning(false);
                }, (error) => {
                    console.error('Error sending campaign:', error);
                    pending -= 1;
                    if (pending === 0) setIsRunning(false);
                });
            } else {
                pending -= 1;
                if (pending === 0) setIsRunning(false);
            }
        }
        if (pending === 0) setIsRunning(false);
    };

    const runAutoCampaign = async () => {
        setIsRunning(true);
        for (let i = 0; i < autoAudienceList.length; i++) {
            const aud = autoAudienceList[i];
            await new Promise((resolve) => {
                sendEmailCampaignAPI(
                    {
                        templateId: templateObj.id,
                        audienceId: aud.id,
                    },
                    (response) => {
                        dispatch(addCampaignObj(response.campaignInfo));
                        setAutoAudienceList(prev =>
                            prev.map(item =>
                                item.id === aud.id ? { ...item, status: 'sent' } : item
                            )
                        );
                        resolve();
                    },
                    (error) => {
                        setAutoAudienceList(prev =>
                            prev.map(item =>
                                item.id === aud.id ? { ...item, status: 'error' } : item
                            )
                        );
                        resolve();
                    }
                );
            });
        }
        setIsRunning(false);
    };

    return (
        <>
            <Grid container>
                
                <Grid item lg={8} md={8} sm={8} xs={12} sx={{ pr: 4 }}>
                    <Grid container direction="column" sx={{ backgroundColor: 'white' }}>
                        <Grid item lg={12} sx={{ padding: 1 }}>
                            <Typography variant="h4" gutterBottom>
                                '{templateObj.title}' Compaign sent to following audiences
                            </Typography>
                            <Divider />
                        </Grid>
                        <Grid item lg={12} sx={{  minHeight:{lg:'70vh', xs:'30vh'}, maxHeight: {lg:'70vh', xs:'30vh'}, overflowY: 'auto' }}>
                            <Grid container direction="row" sx={{ width: '100%',padding:.5 }}>
                                {campaignList && campaignList.map((campaign, index) => (
                                    <>
                                        <Typography key={index} variant="body1" sx={{fontSize:12, color:'primary.dark', backgroundColor: 'secondary.100', borderRadius:2, padding:1}}>
                                            {campaign.audienceemail}
                                        </Typography><span>&nbsp;</span>
                                   </>
                                    
                                ))}
                            </Grid>
                            
                        </Grid>
                         <Divider />
                        </Grid>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={12} sx={{ padding: 1, backgroundColor: 'white' }}>
                    <Grid container direction="column" >
                        <Grid item lg={12} sx={{backgroundColor: 'secondary.100',  }}>
                            
                            <RadioGroup
                                row
                                value={mode}
                                onChange={e => setMode(e.target.value)}
                               sx={{pl:1}}
                            >
                                <FormControlLabel value="manual" control={<Radio />} label="Manual" />
                                <FormControlLabel value="auto" control={<Radio />} label="Auto" />
                                
                            </RadioGroup>
                        </Grid>
                        {mode === 'manual' && (
                        <Box>
                            <Grid item lg={12} sx={{mt:1}}>
                                <Typography variant="h4" gutterBottom>
                                    Audience List
                                </Typography>
                                {/* <Divider /> */}
                            </Grid>
                            <Grid item lg={12} >
                                <TextField
                                    label="Search Audience"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={searchAudience}
                                    onChange={e => setSearchAudience(e.target.value)}
                                    
                                />
                            </Grid>
                            <Grid item lg={12} sx={{ padding: 1,  minHeight:{lg:'40vh', xs:'20vh'}, maxHeight: {lg:'40vh', xs:'20vh'}, overflowY: 'auto' }}>
                                {filteredAudienceList && filteredAudienceList.map((audience, index) => {
                                    // Check if this audience's email is already in any campaign's audienceemail
                                    const isAlreadySent = campaignList.some(c => c.audienceemail === audience.email);
                                    return (
                                        <FormControlLabel
                                            key={index}
                                            control={
                                                <Checkbox
                                                    checked={selectedAudience.includes(audience.id) || isAlreadySent}
                                                    onChange={() => handleCheckboxChange(audience.id)}
                                                    disabled={isAlreadySent}
                                                />
                                            }
                                            label={`${audience.title} - ${audience.email}`}
                                        />
                                    );
                                })}
                            </Grid>
                            <Divider />
                            <Grid item lg={12} sx={{ padding: 1, minHeight:'15vh', maxHeight: '15vh', overflowY: 'auto' }}>
                                <Typography variant="h6" sx={{color: 'primary.main'}}>
                                    Selected Audiences: {selectedAudience.length}
                                </Typography>
                                <Grid container direction="row" sx={{ width: '100%', padding: 1 }}>
                                    {selectedAudience && selectedAudience.map((audId, index) => {
                                        const audObj = audienceList.find(a => a.id === audId);
                                        return (
                                            <Grid item lg={6} key={audId} sx={{ padding: 1 }}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{ fontSize:'12px', color: 'primary.dark', backgroundColor: 'secondary.100', borderRadius: 2, padding: 1 }}
                                                >
                                                    {audObj ? `${audObj.email}` : ''}
                                                </Typography>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                                
                                
                            </Grid>
                            <Grid item lg={12} sx={{ padding: 1, textAlign: 'right' }}>
                                {isRunning ? (
                                    <CircularProgress size={32} />
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={selectedAudience.length === 0}
                                        onClick={() => runCampaign()}
                                    >
                                        Run Campaign
                                    </Button>
                                )}
                            </Grid>
                        </Box>)}

                        {mode === 'auto' && (
                        <Box>
                            <Grid container direction="column" sx={{ backgroundColor: 'white', padding: 1 }}>
                                <Grid item lg={12}>
                                    <Typography variant="h4" sx={{  }}>
                                        Select Audience Count:
                                    </Typography>
                                    <RadioGroup
                                        row
                                        value={audienceCount}
                                        onChange={e => setAudienceCount(Number(e.target.value))}
                                        sx={{ mb: 1 }}
                                    >
                                        <FormControlLabel value={5} control={<Radio />} label="5" />
                                        <FormControlLabel value={10} control={<Radio />} label="10" />
                                        <FormControlLabel value={50} control={<Radio />} label="50" />
                                        <FormControlLabel value={100} control={<Radio />} label="100" />
                                        <FormControlLabel value={200} control={<Radio />} label="200" />
                                    </RadioGroup>
                                </Grid>
                                <Grid item lg={12} sx={{ padding: 1,  minHeight:{lg:'45vh', xs:'20vh'}, maxHeight: {lg:'45vh', xs:'20vh'}, overflowY: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                                        <thead>
                                            <tr style={{ background: '#f5f5f5' }}>
                                                <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ddd' }}>Email</th>
                                                <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ddd' }}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {autoAudienceList && autoAudienceList.map((audience, index) => (
                                                <tr key={index}>
                                                    <td style={{ padding: 8, borderBottom: '1px solid #eee' }}>{audience.email}</td>
                                                    <td style={{ padding: 8, borderBottom: '1px solid #eee' }}>{audience.status}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Grid>
                                <Grid item lg={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={isRunning || autoAudienceList.length === 0}
                                        onClick={() => runAutoCampaign()}
                                    >
                                        Run Auto Campaign
                                    </Button>
                                </Grid>

                            </Grid>
                        </Box>)}
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}